import requester from '@/lib/axios';
import PromptInstruction, {
  PromptInstructionHistory,
  PromptFile,
  PromptCategoryEnum,
} from '@/models/PromptInstruction';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';

type ParentPromptId = number | null;

export type ListPromptInstructionFilter = {
  parentPromptId?: ParentPromptId[];
  ordering?: string;
  isParent?: boolean;
  category?: PromptCategoryEnum[];
} & BaseFilters;

export const listPromptInstructions = async (
  params: ListPromptInstructionFilter = {},
) => {
  const { data } = await requester().get<JsonApiResponse<PromptInstruction>>(
    'astro-ai/prompt-instruction/',
    {
      params,
    },
  );

  return data;
};

export const getPromptInstruction = async (id: number) => {
  const { data } = await requester().get<PromptInstruction>(
    `astro-ai/prompt-instruction/${id}/`,
  );
  return data;
};

export const updatePromptInstruction = async (
  id: number,
  prompt: Partial<PromptInstruction>,
) => {
  const { data } = await requester().patch<PromptInstruction>(
    `astro-ai/prompt-instruction/${id}/`,
    {
      instruction: prompt.instruction,
      role: prompt.role,
    },
  );

  return data;
};

export type ListPromptInstructionHistoryFilter = {
  historyUserId?: number[];
  ordering?: string;
} & BaseFilters;

export const listPromptInstructionHistory = async (
  promptId: number,
  params: ListPromptInstructionHistoryFilter = {},
) => {
  const { data } = await requester().get<
    JsonApiResponse<PromptInstructionHistory>
  >(`astro-ai/prompt-instruction/${promptId}/history/`, {
    params,
  });

  return data;
};

export const uploadPromptFile = async (promptId: number, file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await requester().post<PromptFile>(
    `astro-ai/prompt-instruction/${promptId}/files/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return data;
};

export const deletePromptFile = async (promptId: number, fileId: number) => {
  await requester().delete(
    `astro-ai/prompt-instruction/${promptId}/files/${fileId}/`,
  );
};

export const restorePromptInstructionVersion = async (
  promptId: number,
  historyId: number,
) => {
  const { data } = await requester().patch<PromptInstruction>(
    `astro-ai/prompt-instruction/${promptId}/history/${historyId}/restore/`,
  );

  return data;
};
